import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Services from "./components/Services"; 
import About from "./components/About";
import Gallery from "./components/Gallery";
import TestimonialsCarousel from "./components/TestimonialsCarousel";
import Offers from "./components/Offers";
import Contact from "./components/Contact";
import Footer from "./components/Footer";


function App() {
  return (
    <>
    <Helmet>
  <title>Serenity Salon & Spa | Relaxation, Beauty & Wellness</title>
  <meta
    name="description"
    content="Rejuvenate your mind and body at Serenity Salon & Spa. Enjoy expert hair styling, soothing massages, and luxurious beauty treatments."
  />
  <link rel="canonical" href="https://websolutionusa.com/templates/saloon/" />
  <meta property="og:title" content="Serenity Salon & Spa | Relaxation, Beauty & Wellness" />
  <meta
    property="og:description"
    content="Experience ultimate relaxation and professional care with our salon and spa services — from hair and skincare to massages and wellness therapies."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://websolutionusa.com/templates/saloon/" />
  <meta property="og:image" content="https://websolutionusa.com/templates/saloon/images/salon-spa-og-image.jpg" />
</Helmet>


      <Header />
      <Banner />
      <Services />
      <About />
      <Gallery />
      <TestimonialsCarousel />
      <Offers />
      <Contact />
      <Footer />
      <main>
        {/* Your page content */}
      </main>
    </>
  );
}

export default App;
